var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExportCsv = function SvgExportCsv(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/16*16/functional-actions/file-report"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76532 18.1234C7.62394 18.1234 6.69866 17.1981 6.69866 16.0567L6.69866 8.05671C6.69866 6.91532 7.62394 5.99004 8.76532 5.99004H11.6608C11.8323 5.99004 12.0017 6.01137 12.1653 6.05257L12.1653 8.05671C12.1653 9.86084 13.6279 11.3234 15.432 11.3234L17.4361 11.3234C17.4773 11.487 17.4987 11.6564 17.4987 11.8279V16.0567C17.4987 17.1981 16.5734 18.1234 15.432 18.1234L8.76532 18.1234ZM16.6501 10.1234H15.432C14.2906 10.1234 13.3653 9.19809 13.3653 8.05671V6.83857L16.6501 10.1234ZM5.49866 16.0567C5.49866 17.8608 6.96119 19.3234 8.76532 19.3234H15.432C17.2361 19.3234 18.6987 17.8608 18.6987 16.0567V11.8279C18.6987 10.9616 18.3545 10.1307 17.7419 9.51806L13.9706 5.74682C13.358 5.1342 12.5271 4.79004 11.6608 4.79004H8.76532C6.96119 4.79004 5.49866 6.25258 5.49866 8.05671L5.49866 16.0567Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6743 16.8228C11.9086 17.0571 12.2885 17.0571 12.5229 16.8228L14.4623 14.8834C14.6966 14.6491 14.6966 14.2692 14.4623 14.0348C14.2279 13.8005 13.848 13.8005 13.6137 14.0348L12.6986 14.95V12.3985C12.6986 12.0671 12.43 11.7985 12.0986 11.7985C11.7672 11.7985 11.4986 12.0671 11.4986 12.3985V14.95L10.5835 14.0348C10.3492 13.8005 9.96925 13.8005 9.73494 14.0348C9.50063 14.2692 9.50063 14.6491 9.73494 14.8834L11.6743 16.8228Z",
    fill: "#595959"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExportCsv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "exportCsv.7ad44147f5642a2d78d8cbae8d822028.svg";